export const getSocialMediaStyles = () => ({
  socialMediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  textField: {
    paddingBottom: 16,
  },
  socialMediaRoot: {
    paddingTop: 22,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});
